import { useState, useEffect, useRef, Fragment, memo, useMemo } from "react";
import style from "./../index.module.scss";
import styleUi from "./JoinRequest.module.scss";
import allStyle from "./../../comm/global/all.module.scss";
import { v4 } from "uuid";
import styled from "styled-components";
import apiManager from './../../ApiManager';
import { CSSTransition } from 'react-transition-group';
import * as YStyled from "../../Styleds";
import ImageLoader from "../../comm/global/components/ImageLoader";
import { borderRadius } from "polished";

const JoinRequest = ({ setModalType, arg, addModalType }) => {
    const [inProp, setInProp] = useState(false);
    useEffect(() => {
        setInProp(true);
        document.title = "優惠券";
    }, [])

    return (
        <div className={style.modal}>
            <CSSTransition in={inProp} timeout={{
                appear: 0,
                enter: 300,
                exit: 0,
            }} classNames={{
                enterActive: style.SwipePageEnterActive,
                enterDone: style.SwipePageEnterDone,
                exitActive: style.SwipePageExit,
                exitDone: style.SwipePageExitActive
            }}
                onExited={async () => {
                    await new Promise(resolve => requestAnimationFrame(resolve));
                    setModalType(prev => prev.filter(v => v.cls !== "JoinRequest"))
                }}
            >
                <div className={`${style.SwipePage} ${style.Page}`} >
                    <div className={styleUi.app}>
                        <div className={styleUi.headerBar}>
                            <img src="./assets/ui/back.png" onClick={e => { setInProp(false) }} />
                        </div>
                        <div className={styleUi.view}>
                            <YStyled.Label style={{ width: "100%" }}>
                                <YStyled.Col gap="1rem">
                                    <YStyled.Row align="center">
                                        <ImageLoader style={{ borderRadius: "50%", width: "2rem" }} variant={"circular"} src={""} />
                                        <YStyled.Span size="15" color="#3149CE">{arg.joinVo.notifications_message.data[0].users_name}</YStyled.Span>
                                    </YStyled.Row>
                                    <YStyled.Row align="center">
                                        <YStyled.Span size="15">想加入</YStyled.Span>
                                        <YStyled.Span size="15" color="#3149CE">{arg.joinVo.notifications_message.data[1].events_name}</YStyled.Span>
                                    </YStyled.Row>

                                    <YStyled.Row align="center" gap=".4rem">
                                        <YStyled.BTN3 normalBg="white" normalColor="#3149CE" style={{ border: "solid 1px #3149CE", borderRadius: "8px", padding: ".4rem ", flexGrow: "1" }} onClick={e => {
                                            apiManager.fetchPut(`event-invitations/${arg.joinVo.notifications_identifier}?applied=true`, { event_participants_status: 2 }, 0).then(res => {
                                                console.log("res", res);
                                            });
                                        }}>
                                            <YStyled.Span size={15}>婉拒</YStyled.Span>
                                        </YStyled.BTN3>
                                        <YStyled.BTN3 normalBg="#3149CE" normalColor="white" style={{ border: "solid 1px #3149CE", borderRadius: "8px", padding: ".4rem ", flexGrow: "1" }} onClick={e => {
                                            apiManager.fetchPut(`event-invitations/${arg.joinVo.notifications_identifier}?applied=true`, { event_participants_status: 1 }, 0).then(res => {
                                                console.log("res", res);
                                            });
                                        }}>
                                            <YStyled.Span size={15}>接受</YStyled.Span>
                                        </YStyled.BTN3>
                                    </YStyled.Row>
                                    {arg.joinVo.notifications_message.data[2]?.event_participants_request_message !== "" &&
                                        <>
                                            <YStyled.Hr></YStyled.Hr>
                                            <YStyled.Span size="15">{`${arg.joinVo.notifications_message.data[0].users_name} ${arg.joinVo.notifications_message.data[0].users_username?`(@${arg.joinVo.notifications_message.data[0].users_username})`:""} 的留言：`}</YStyled.Span>
                                            <YStyled.Span size="15">{arg.joinVo.notifications_message.data[2].event_participants_request_message}</YStyled.Span>
                                        </>
                                    }
                                </YStyled.Col>
                            </YStyled.Label>
                        </div>
                    </div>
                </div>
            </CSSTransition>
        </div>
    );
}

export default memo(JoinRequest);